import React from "react";
import Sidebar from "./Sidebar";
import { BarChart2, FileText, Settings } from "lucide-react";

const Dashboard = () => {
  return (
    <div className="flex min-h-screen bg-gray-100">
      <Sidebar />

      {/* Centered Main Content */}
      <div className="w-full min-h-screen flex items-center justify-center p-4 bg-gray-100">
      <div className="bg-white rounded-xl shadow-lg p-6 md:p-10 w-full">
    <h1 className="text-3xl font-bold text-gray-800 mb-10 text-center">
      Dashboard
    </h1>

    <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6">
      {/* Card 1 */}
      <div className="bg-blue-100 hover:bg-blue-200 transition duration-300 p-6 rounded-xl shadow-md">
        <div className="flex items-center mb-4">
          <BarChart2 className="text-blue-700 w-6 h-6 mr-2" />
          <h2 className="text-xl font-semibold text-blue-800">Analytics</h2>
        </div>
        <p className="text-gray-700">
          View your analytics and performance metrics.
        </p>
      </div>

      {/* Card 2 */}
      <div className="bg-green-100 hover:bg-green-200 transition duration-300 p-6 rounded-xl shadow-md">
        <div className="flex items-center mb-4">
          <FileText className="text-green-700 w-6 h-6 mr-2" />
          <h2 className="text-xl font-semibold text-green-800">Reports</h2>
        </div>
        <p className="text-gray-700">
          Access and download your generated reports.
        </p>
      </div>

      {/* Card 3 */}
      <div className="bg-purple-100 hover:bg-purple-200 transition duration-300 p-6 rounded-xl shadow-md">
        <div className="flex items-center mb-4">
          <Settings className="text-purple-700 w-6 h-6 mr-2" />
          <h2 className="text-xl font-semibold text-purple-800">Settings</h2>
        </div>
        <p className="text-gray-700">
          Customize and manage your account preferences.
        </p>
      </div>
    </div>
  </div>
</div>

    </div>
  );
};

export default Dashboard;
